// File: voces-de-esperanza/src/config/cuenta.js
//
// "Hoy" archivado (project-log/initiatives/cuenta-simple-equipo.md, 2026-10-26). La
// plataforma se enfoca por ahora en admin y el equipo de voces: con sesión, /mi-cuenta/
// muestra una cuenta simple (botón al panel que te toca + devocionales guardados).
//
// El panel "Hoy" (devocional, programas, acompañamiento, FRUTO, mentor) sigue completo en
// mi-cuenta.js y en Layout.js: poner esto en `true` lo devuelve tal cual, junto con el ítem
// "Hoy" del menú y los avisos que llevaban a él. Se rescatará como panel de quienes estudian.
export const SHOW_HOY = false;
